import React from 'react';
import { VisitorRow } from './ReceptionList.styled';
import { Button } from 'react-bootstrap';
import { IReceptionListItemProps } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ReceptionDesktopListItem = React.memo<IReceptionListItemProps>(
  ({ visitor, signedOut, isSigningOut, onClick, onSignOut }) => {
    return (
      <VisitorRow signedOut={signedOut} onClick={onClick}>
        <td>
          <FontAwesomeIcon icon={visitor.visitorType.icon} size="lg" />
        </td>
        <td>{visitor.surname}</td>
        <td>{visitor.firstNames}</td>
        <td>{visitor.company}</td>
        <td>{visitor.carRegistration}</td>
        <td>{visitor.emailAddress}</td>
        <td>{visitor.mobile}</td>
        <td>{visitor.host}</td>
        <td>
          {visitor.inAt.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          })}
        </td>
        <td>
          {isSigningOut ? (
            <span>...</span>
          ) : signedOut ? (
            visitor.outAt!.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
          ) : (
            <Button
              className="w-100"
              type="button"
              variant="danger"
              size="sm"
              onClick={(event: React.SyntheticEvent) => {
                event.stopPropagation();
                onSignOut();
              }}
            >
              Sign Out
              {visitor.badgeDescription?.length > 0 &&
                ` - ${visitor.badgeDescription}`}
            </Button>
          )}
        </td>
        <td>
          {visitor.triggeredQuestionnaireAlert && (
            <FontAwesomeIcon
              icon="exclamation-triangle"
              className="text-warning"
            />
          )}
        </td>
      </VisitorRow>
    );
  },
);
